/**
 * Removes consecutive duplicate words from a string, ignoring case.
 *
 * Splits the input string into words, compares each word to the previous one (case-insensitive),
 * and constructs a new string with consecutive duplicates removed.
 *
 * @param str - The input string to process.
 * @returns A new string with consecutive duplicate words removed.
 *
 * @example
 * ```typescript
 * removeConsecutiveDuplicateWords("Hello hello world world"); // "Hello world"
 * ```
 */
export const removeConsecutiveDuplicateWords = (str: string): string => {
  const words = str.split(/\s+/);
  const result: string[] = [];

  for (let i = 0; i < words.length; i++) {
    if (i === 0 || words[i].toLowerCase() !== words[i - 1].toLowerCase()) {
      result.push(words[i]);
    }
  }

  return result.join(' ');
};
